/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { Spin, message } from 'antd'
import request from '../../utils/request'
import Icon from '../icon'
import './tagList.less'

const API = {
  ALL_DATA: 'zhikuan/img-tag/list-tag',
  HISTORY_DATA: 'zhikuan/img-tag/user-record-list',
  DELETE_HISTORY: 'zhikuan/img-tag/delete-use-record'
}
const MAX_LENGTH = 100
let timeoutId = 0
export default function TagListHistory({ onAdd, onDelete, visible, value = new Set() }) {
  const [searchData, setSearchData] = useState([])
  const [keyword, setKeyword] = useState('')
  const [loading, setLoading] = useState(false)
  const [historyData, setHistoryData] = useState([])
  useEffect(() => {
    actions.fetchHistoryData()
  }, [visible])
  useEffect(() => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      actions.fetchSearchResult(keyword)
    }, 600)
  }, [keyword])
  const actions = {
    async fetchSearchResult(keyword) {
      if (!keyword) {
        return
      }
      const result = await request.spost(API.ALL_DATA, { pageSize: 30, rankStatus: 1, tagName: keyword }, 'tag-history')
      setSearchData(result.resultList || [])
      setLoading(false)
    },
    async fetchHistoryData() {
      const result = await request.sget(API.HISTORY_DATA)
      setHistoryData(result)
    },
    async clearHistoryData() {
      await request.post(API.DELETE_HISTORY, {})
      setHistoryData([])
    },
  }
  const events = {
    onKeyDown(e) {
      if (e.keyCode === 13) {
        events.onClickSearchItem(e.target.value)
      }
    },
    onClearItems() {
      actions.clearHistoryData()
    },
    onChange(e) {
      if (e.target.value.length >= MAX_LENGTH) {
        message.error(`单个标签字数不可超过${MAX_LENGTH}字哦～`)
        return
      }
      setLoading(!!e.target.value)
      setKeyword(e.target.value)
    },
    onClickSearchItem(tagName) {
      setKeyword('')
      events.onClickItem(tagName)
    },
    onClickItem(tagName) {
      if (value.has(tagName)) {
        // 执行删除操作
        onDelete?.(tagName)
        return
      }
      // 添加操作
      onAdd?.(tagName)
    }
  }
  const renderer = {
    listMap(m) {
      return <li
        className={classNames({ active: value.has(m.tagName) })}
        onClick={() => events.onClickItem(m.tagName)}
      >{m.tagName}</li>
    },
    searchList() {
      if (searchData.length === 0 && !loading) {
        return <li onClick={() => events.onClickSearchItem(keyword)}>新增“{keyword}”标签</li>
      }
      return searchData.map(renderer.listMap)
    }
  }
  return <div className="df-tag-list-history">
    <div className="search-tag">
      <Icon type="m-sousuo" />
      <input className="text-box" value={keyword} onKeyDown={e => events.onKeyDown(e)} maxLength={MAX_LENGTH} placeholder="搜索或新增标签" onInput={e => events.onChange(e)} />
    </div>
    {!!keyword.length && <Spin spinning={loading} indicator={<Icon type="m-jiazaizhong" spin />}><ul className="items">
      {renderer.searchList()}
    </ul>
    </Spin>}
    {!keyword.length && historyData.length > 0 && <>
      <div className="mini-header">
        <span>最近使用</span><a className="clear" onClick={() => events.onClearItems()}>清除记录</a>
      </div>
      <ul className="items">
        {historyData.map(renderer.listMap)}
      </ul>
    </>}
  </div>
}
